import React from "react";
import { Container } from "react-bootstrap";

export default function Profilereview() {
  return (
    <section className="profile-singlewrap">
      <div className="Profile-single profile-viewer position-relative">
        <div className="overlay-gra"></div>
      </div>
      <Container>
        <div className="profile-content-overlap">
          <div className="profilimg">
            <img src="images/userreiview.png" alt="" className="img-fluid" />
          </div>
          <div className="profile-cont text-center">
            <h2>Bill Anton</h2>
            <p>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
              >
                <path
                  d="M25.6667 13.9997C25.6667 7.55618 20.4435 2.33301 14 2.33301C7.55651 2.33301 2.33334 7.55618 2.33334 13.9997C2.33334 20.4432 7.55651 25.6663 14 25.6663"
                  stroke="#252629"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M15.1667 2.3916C15.1667 2.3916 18.6667 6.99993 18.6667 13.9999M12.8333 25.6083C12.8333 25.6083 9.33333 20.9999 9.33333 13.9999C9.33333 6.99993 12.8333 2.3916 12.8333 2.3916M3.06833 18.0833H14M3.06833 9.9166H24.9317"
                  stroke="#252629"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M25.5255 20.9032C26.1018 21.2579 26.0657 22.1201 25.473 22.1877L22.4782 22.5272L21.1353 25.2246C20.8693 25.7601 20.0468 25.4976 19.9103 24.8349L18.4462 17.6996C18.3307 17.1396 18.8347 16.7872 19.3212 17.0871L25.5255 20.9032V20.9032Z"
                  stroke="#252629"
                  stroke-width="1.5"
                />
              </svg>
              https://www.instagram.com/sempiira.nyaagwa
            </p>
          </div>

          <div className="bio-div text-center">
            <h4>Bio</h4>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Blandit
              consectetur dignissim faucibus donec viverra tempus purus Lorem
              ipsum dolor sit amet, consectetur adipiscing elit. Blandit
              consectetur dignissim
            </p>
          </div>
        </div>
      </Container>
    </section>
  );
}
